module.exports = __webpack_public_path__ + "static/icon-80cf999705024d9f7de8438f9ee532bd.png";